<template>
	<div class="flex flex-row items-center" v-if="this.isShowComponent">
		<div class="flex flex-wrap">
      <img class="w-18 h-18 rounded-full border-grey-light border-2"
      :src="this.userImageUrl" alt="Avatar of user"
       v-bind:class="{ 'border-pink-light': isPremium}">
    </div>
    
    <div class="mx-4">
      <div class="text-grey-darkest leading-none font-bold text-2xl">{{this.userDisplayedName}}</div>
      <p class="pt-1 text-base text-pink-light">Beta user</p>
    </div>
  </div>
</template>

<script>
import AuthController from "../controllers/AuthController";

export default {
  name: "ProfileHeader",
  data() {
    return {
      logoutButtonText: "",
      userImageUrl: "",
      userDisplayedName: "",
      isShowComponent: false,
      isPremium: false,
    };
  },

  created() {
    this.logoutButtonText = "Logout";
    AuthController.isLoggedIn(result => { 
      this.isShowComponent = result != null;
      if(this.isShowComponent) {
        this.userImageUrl = AuthController.userImageUrl();
        this.userDisplayedName = AuthController.displayName();

        this.isPremium = AuthController.userEmail() === 'joaquimley@gmail.com' // TODO -> Check isPremium flag from backend
      }
      
    });
  },

  methods: {
    logoutUser() {
      AuthController.logout()
        .then(() => {
          this.$router.replace("welcome");
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProfileHeader.vue